import { render } from "./opTable.vue?vue&type=template&id=5f9cfd34&ts=true"
import script from "./opTable.vue?vue&type=script&lang=ts"
export * from "./opTable.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__